import * as actionTypes from './excelActionTypes';

export const setProcessedExcel = (processedExcel) => ({type: actionTypes.PROCESSED_EXCEL, processedExcel:processedExcel});
export const setTransforming = (transforming) => ({type: actionTypes.TRANSFORMING, transforming:transforming});